var jquery = require ("jquery");//TODO: Upgrade to 3.0 & fix compat issues
window.$ = jquery;
window.jQuery = jquery;
require ("es6-promise/auto");
require ("./pvplib/PVPGEngine.js");
require ("./pvplib/FunctionList.js");
require ("./pvplib/Signal.js");
require ("./pvplib/server.js");
require ("./pvplib/wait.js");
require('./fragment/gdprPopup.js');